import { loadDashboards } from '../api/dashboards';
import { useResourcesStore } from 'vince-core/stores/resourcesStore';
import { Action } from 'vince-core/types/roles';
import { ResourceType, type ResourceItem } from 'vince-core/types/common';

export default defineNuxtPlugin(() => {
    const store = useResourcesStore();
    store.registerResource('DASHBOARD', 'menus.dashboards', [Action.WRITE, Action.READ], async () => {
        return await loadDashboards({ limit: 5000 }).then((dashboards) => {
            return dashboards.items.map((it) => {
                return {
                    id: it.dashboardId!,
                    key: it.dashboardName,
                    label: it.dashboardName,
                    permissionValue: it.dashboardName,
                    permissionLabel: it.dashboardAlias || it.dashboardName,
                    description: it.description,
                    resourceType: 'DASHBOARD',
                    usable: true
                } as ResourceItem;
            });
        });
    }, undefined, [ResourceType.DASHBOARD]);
});
